import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { ChevronDown as ChevronDownIcon } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';
import { Chat } from '@mint-sdk/api-ai-assistant';

import { Accordion, AccordionDetails, AccordionSummaryBasic } from '@myn/mui';

import { ProcessDetailsView } from '../ui/ProcessDetailsView.jsx';

type Props = {
  reasoningData: Chat.AiChatMessageRecordType[];
  webSources: string[];
  knowledgeBaseSources: string[];
};

const ReasoningSummaryAccordion = ({
  reasoningData,
  knowledgeBaseSources,
  webSources,
}: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const [isExpanded, setIsExpanded] = useState(false);

  const isAccordionHidden =
    !reasoningData.length && !knowledgeBaseSources.length && !webSources.length;

  if (isAccordionHidden) {
    return null;
  }

  return (
    <Accordion
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      <AccordionSummaryBasic
        expandIcon={<ChevronDownIcon className="fill-icon-primary" />}
        sx={{ height: '40px' }}
      >
        <div className="flex items-center">
          <p className={typographyVariants({ variant: 'bodyShort02' })}>
            {t('Process details')}
          </p>
        </div>
      </AccordionSummaryBasic>
      <AccordionDetails>
        <ProcessDetailsView
          reasoningData={reasoningData}
          webSources={webSources}
          knowledgeBaseSources={knowledgeBaseSources}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export { ReasoningSummaryAccordion };
